import { render, staticRenderFns } from "./RequiredFieldTable.vue?vue&type=template&id=b40764de"
import script from "./RequiredFieldTable.vue?vue&type=script&lang=ts"
export * from "./RequiredFieldTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports